module.exports = __webpack_public_path__ + "static/media/drone-centre.b09a23ec.png";